import React, { createContext, useContext } from "react";
import { NoopAnalytics } from "./index";
import { Analytics } from "./types";

/**
 * Defaults to NoopAnalytics so components rendered without a provider (e.g. in tests) don't send
 * anything.
 */
export const AnalyticsContext = createContext<Analytics>(NoopAnalytics);

export interface AnalyticsProviderOptions {
  children: React.ReactNode;
  analytics?: Analytics;
}

export const AnalyticsProvider = ({
  children,
  analytics = NoopAnalytics,
}: AnalyticsProviderOptions): JSX.Element => (
  <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>
);

/**
 * Use the `useAnalytics` hook in your components to get the app's analytics instance.
 */
export const useAnalytics = (): Analytics => useContext(AnalyticsContext);
